import React from "react";
import { Media } from "../../../global";
import { getStrapiMedia } from "@/utils/api-helpers";
import Image from "next/image";
import { formatDate } from "@/utils/dateFormatter";

export interface NewsCardProps {
  title: string;
  date: string;
  tag: string;
  image: Media;
}

export default function NewsCard({ title, date, tag, image }: NewsCardProps) {
  return (
    <div className="relative rounded-2xl overflow-hidden hover:cursor-pointer transition-all hover:scale-105 h-full flex flex-col">
      <div className="relative flex flex-col">
        <div className="absolute top-0 right-0 bottom-0 left-0 w-full h-[50%] bg-gradient-to-b from-[#00000080] to-transparent z-0 pointer-events-none"></div>
        <div className="absolute top-5 left-5 border-[1px] border-white py-0 px-4 rounded-md">
          <span className="text-white mb-0 font-medium uppercase text-sm">
            {tag}
          </span>
        </div>
        <Image
          src={
            image?.url
              ? getStrapiMedia(image.url)
              : "/backup-thumbnail.webp"
          }
          alt={image?.alternativeText || ""}
          width={500}
          height={400}
          className="object-cover w-full"
          loading="lazy"
        />
      </div>
      <div className="bg-white sm:pb-6 p-6 flex flex-col flex-grow">
        <p className="text-purple font-medium text-sm mb-2">
          {formatDate(date)}
        </p>
        <h3 className="text-darkGrey2 text-lg">{title}</h3>
      </div>
    </div>
  );
}
